/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { Config } from '../models/Config';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class ConfigApiResource {

    /**
     * Return global config
     * 
     */
    public getConfig(axiosConfig?: AxiosRequestConfig): Promise<Config> {
        const reqPath = '/v1/config';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Update global config
     * 
     * @param body Config data to update
     */
    public updateConfig(body?: Partial<Config>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/config';
        let reqConfig = {
            ...axiosConfig,
            method: 'PATCH',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const ConfigApi = new ConfigApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/ConfigApi.ts